<template lang="pug">
  .sub-frequency-tag.xs-f-xxsmall.max-at-tweak
    slot
    span.upper.inline-block Delivered every {{ frequency }} weeks

</template>

<script>
  export default {
    name: "SubFrequencyTag",
    props: {
      frequency: {
        type: [String, Number],
        required: true
      }
    }
   }
</script>

<style scoped lang="stylus">
  .sub-frequency-tag
    display inline-block
    border 2px solid
    border-color color-fog-light
    border-radius 4px
    padding 0.1em 0.3em

</style>